module.exports = __webpack_public_path__ + "img/markers.fcd44821.svg";